<template>
	<section class="not-found-container">
		<h1>Page Not Found</h1>
		<p>The page you navigated to was not found.</p>
		<p v-if="!userInPilot">
			Please return <router-link to="/">to the Dashboard</router-link>.
		</p>
		<p v-if="userInPilot">
			Please return
			<a href="https://mkt.uwm.com/leadpipeline" target="_blank"
				>to the Lead Pipeline</a
			>.
		</p>
	</section>
</template>
<script>
import { mapState } from 'vuex';
export default {
	name: 'NotFound',
	computed: {
		...mapState({
			userInPilot: (state) => state.profile.isPilotUser,
		}),
	},
};
</script>

<style lang="scss" scoped>
.not-found-container {
	margin-top: -$context-nav-height;
	overflow-x: hidden;
	padding-left: 1rem;
}
h1 {
	color: $brand-blue;
}
</style>
